export default __webpack_public_path__ + "static/media/walletconnect-logo.dfa25e47.svg";